import { FamilyModel } from '@modules/family/family-model';

const { fields } = FamilyModel;

export default [
    fields.id,

    fields.createdAt
];